/**
 * Triggers a browser file download for an object URL with the specified filename,
 * then revokes the object URL.
 */
export const downloadBlob = (url: string, filename: string): void => {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
